// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  ME: '/user/me',
  UPDATE_PROFILE: '/update-profile',
  DELETE_USER: '/user',
  
  // Tasks
  GET_TASKS: '/gettasks2',
  GET_ARCHIVE_TASKS: '/getarchivetasks',
  CREATE_TASK: '/addtask',
  UPDATE_TASK: '/edittask',
  DELETE_TASK: '/deletetask',
  DELETE_COMPLETED_TASK: '/deletecompletedtask',
  ARCHIVE_TASK: '/movetask',
  ARCHIVE_COMPLETED_MONTH: '/archive-completed-month',
  UPDATE_POSITIONS: '/updatepositions',
  
  // Categories
  GET_CATEGORIES: '/categories',
  
  // Developers
  GET_DEVELOPERS: '/devs',
  ACTIVATE_DEVELOPER: '/developers',
  DEACTIVATE_DEVELOPER: '/developers',
  
  // Projects
  GET_PROJECTS: '/projects',
  GET_ALL_PROJECTS: '/projects/all',
  DELETE_PROJECT: '/projects',
  DELETE_PROJECT_PERMANENT: '/projects',
  
  // Telegram
  SEND_TO_TELEGRAM: '/generate-developer-report',
  
  // Bug reports
  BUG_REPORTS: '/bug-reports',

  // Telegram Settings
  TELEGRAM_SETTINGS: '/telegram-settings',
  TELEGRAM_SETTINGS_TEST: '/telegram-settings/test',
  TELEGRAM_SETTINGS_STATS: '/telegram-settings/stats',
  TELEGRAM_SETTINGS_INITIALIZE: '/telegram-settings/initialize',
  TELEGRAM_SETTINGS_SEND_TEST_MESSAGE: '/telegram-settings/send-test-message',
  TELEGRAM_SETTINGS_SEND_TEST_REPORT: '/telegram-settings/send-test-report',
  
  // User Settings
  USER_SETTINGS: '/user-settings',
  UPDATE_USER_SETTINGS: '/user-settings',
  
  // Project Settings
  PROJECT_SETTINGS: '/project-settings',
  
  // Analytics
  MONTHLY_HOURS: '/analytics/monthly-hours',
  USERS_ANALYTICS: '/analytics/users-analytics',
  USER_STATS: '/analytics/user-stats',
  SEND_TASK: '/sendtask',
  GENERATE_REPORT: '/generate-developer-report',
  GET_USER_SETTINGS: '/user-settings',
  RESTORE_TASK: '/restoretask',
  TOGGLE_TIMER: '/toggletimer'
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

// Response Status Codes
export const STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

export default API_ENDPOINTS; 